import React, { useState } from "react";
import img7 from "../imgs/img7.png";
import img14 from "../imgs/img14.png";
import img15 from "../imgs/img15.png";
import img16 from "../imgs/img16.png";
import img17 from "../imgs/img17.png";
import Col from "./col";
import Footer from "../footer/footer";

export default function Black() {
  const [isDownloading, setIsDownloading] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const handleDownload = () => {
    setIsDownloading(true);
    setCountdown(5);
    
    // Start countdown
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          // Trigger download when countdown reaches 0
          const link = document.createElement('a');
          link.href = 'https://github.com/swapansuvo64/app-releae/releases/download/v1.0.0/application-8cb49961-6a49-44da-8b41-b694a0e2b82a.apk'; // Make sure this matches your APK file name in public folder
          link.download = 'otaku-app.apk';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setIsDownloading(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  return (
    <div className="absolute w-full h-[full] mt-[-17%] bg-[#141414] flex flex-col  z-[100] rounded-t-[20px] text-white">
      {/* Content here if needed */}
      <img
        src={img7}
        alt="Smaller Image"
        className="w-[80%] mt-[16%] object-contain"
      />
      <div className=" w-full h-full mt-[13%] justify-center text-left px-[9%]  text-white z-20">
        <h1 className="text-[27px] sm:text-[28px] md:text-[35px] font-bold leading-snug sm:leading-tight">
          WHY SHOULD YOU CHOOSE OTAKU<span className="text-yellow-400">'S</span> FOR FREE ANIME AND MANGA ?
        </h1>
      </div>
      <Col />
      <img
        src={img14}
        alt="Smaller Image"
        className="w-[80%] mt-[16%] object-contain ml-auto"
      />
      <div className="mt-[13%] justify-center text-left px-[5%] flex flex-row  text-white z-20 mr-[15%]">
        <h1 className="text-[27px] sm:text-[28px] md:text-[35px] font-bold leading-snug sm:leading-tight">
          IS OTAKU<span className="text-[#FF9500]">'S</span> SAFE ?
        </h1>
        <img
          src={img15}
          alt="Smaller Image"
          className=" object-contain ml-[2%]"
        />
      </div>
      <div className="mt-[6%] justify-center text-[18px] text-left px-[10%] font-bold  text-white z-20">
        We know how important it is to have a trusted and secure platform for watching anime and reading manga. With Otaku<span className="text-[#FF9500]">'S</span>, you never have to worry about harmful ads, shady links, or unreliable sources. Our app ensures a smooth, risk-free experience with high-quality content, regular updates, and a user-friendly design that makes watching and reading effortless.
      </div>

      <div className="bg-[#FF9500] mt-[8%] h-2 w-[80%] rounded-full mx-auto"></div>

      <div className="bg-[#000] mt-[8%] h-[200px] w-[80%] rounded-lg mx-auto flex flex-col justify-center items-center">
        <img
          src={img16}
          alt="Smaller Image"
          className=" object-contain "
        />
        <button 
          onClick={handleDownload}
          disabled={isDownloading}
          className="mt-6 w-[90%] bg-[#494949] h-[70px] gap-3 rounded-[33px] border-[4px] border-[#FF9500] text-white flex flex-row px-5 justify-center items-center"
        >
          <img
            src={img17}
            alt="Smaller Image"
            className=" object-contain "
          />
          <div className="text-[14px] font-bold">
            {isDownloading ? `Starting in ${countdown}s...` : `Download for `}
            {!isDownloading && <span className="text-[#FF9500]">ANDROID</span>}
          </div>
        </button>
        {isDownloading && (
          <p className="mt-2 text-[#FF9500] text-sm font-bold">
            Your download will begin automatically...
          </p>
        )}
      </div>
      <Footer />
    </div>
  );
}